import React from 'react';

import ButtonKit from '@components/common/ButtonKit';
import {
  DeleteAllButton,
  RuleBuilderHeader,
  RuleBuilderTitle,
  TransformFooter,
} from '@components/data-transform-panel/components/TransformRuleBuilder/styled';
import { ITransformRuleBuilder } from '@components/data-transform-panel/components/TransformRuleBuilder/typed';
import TransformRuleGroup from '@components/data-transform-panel/components/TransformRuleGroup';
import { ETransformRuleActionType } from '@components/data-transform-panel/typed';
import { Icon } from '@components/metrics-builder/components/MetricList';
import AddRuleIconSvg from '@icons/mapping-panel/add-rule-icon.svg';

const TransformRuleBuilder: React.FC<ITransformRuleBuilder> = ({
  activeIndices,
  data,
  updateActiveIndices,
  onChange,
  onRulesChange,
  onDragEnd,
  metadataList = [],
  noDeleteAll,
  errorField,
}) => {
  const activeOrIndex = activeIndices?.orIndex;

  const handleDeleteTransformMetadataGroup = (orIndex: number) => {
    if (activeOrIndex !== undefined) {
      if (activeOrIndex === orIndex) {
        updateActiveIndices?.();
      } else if (activeOrIndex > orIndex) {
        updateActiveIndices?.(activeOrIndex - 1);
      }
    }
    onRulesChange?.(ETransformRuleActionType.DELETE_TRANSFORM_METADATA_GROUP, orIndex);
  };

  return (
    <div>
      <RuleBuilderHeader>
        <RuleBuilderTitle>Transform When:</RuleBuilderTitle>
        {!noDeleteAll ? (
          <DeleteAllButton
            onClick={() => onRulesChange?.(ETransformRuleActionType.DELETE_ALL_TRANSFORM)}
          >
            Delete All
          </DeleteAllButton>
        ) : null}
      </RuleBuilderHeader>
      {data?.map((orRuleGroup, orIndex) => {
        return (
          <TransformRuleGroup
            metaNameError={errorField === 'metaName'}
            ruleError={errorField === 'rule'}
            key={`transformRule_${orIndex}`}
            orIndex={orIndex}
            activeIndices={activeIndices}
            data={orRuleGroup}
            updateActiveIndices={(...rest) => updateActiveIndices?.(orIndex, ...rest)}
            onChange={(...rest) => onChange?.(orIndex, ...rest)}
            onDeleteTransformMetadataGroup={() => handleDeleteTransformMetadataGroup(orIndex)}
            onDeleteTransformMetadataItem={(...rest) =>
              onRulesChange?.(
                ETransformRuleActionType.DELETE_TRANSFORM_METADATA_ITEM,
                orIndex,
                ...rest,
              )
            }
            onAddAndTransformMetadataItem={() =>
              onRulesChange?.(ETransformRuleActionType.ADD_AND_TRANSFORM_METADATA_ITEM, orIndex)
            }
            onAddOrTransformMetadataItem={() =>
              onRulesChange?.(ETransformRuleActionType.ADD_OR_TRANSFORM_METADATA_ITEM, orIndex)
            }
            onLogicChange={(...rest) =>
              onRulesChange?.(ETransformRuleActionType.LOGIC_OPERATOR_CHANGE, orIndex, ...rest)
            }
            onDragEnd={onDragEnd}
            metadataList={metadataList}
          />
        );
      })}
      <TransformFooter
        onClick={() => onRulesChange?.(ETransformRuleActionType.ADD_TRANSFORM_METADATA_GROUP)}
      >
        <ButtonKit
          kitType="primary"
          borderColor="transparent"
          backgroundColor="transparent"
          style={{ height: '24px', padding: '2px 6px', fontWeight: 400 }}
          prefix={<Icon component={AddRuleIconSvg} />}
        >
          Add New Metadata
        </ButtonKit>
      </TransformFooter>
    </div>
  );
};

export default TransformRuleBuilder;
